// extracted by mini-css-extract-plugin
export var active = "PortfolioSlider-module--active--a47c0";
export var activeIndex = "PortfolioSlider-module--activeIndex--7650d";
export var arrowButton = "PortfolioSlider-module--arrowButton--6c8c3";
export var cMarginTop = "PortfolioSlider-module--c-margin-top--04c8e";
export var cPadding = "PortfolioSlider-module--c-padding--cab7f";
export var cPaddingBottom = "PortfolioSlider-module--c-padding-bottom--2c315";
export var cPaddingTop = "PortfolioSlider-module--c-padding-top--15272";
export var card = "PortfolioSlider-module--card--bc930";
export var cards = "PortfolioSlider-module--cards--f7cbf";
export var cardsWrapper = "PortfolioSlider-module--cardsWrapper--bf42f";
export var categoryButtons = "PortfolioSlider-module--categoryButtons--7443a";
export var categoryDropdown = "PortfolioSlider-module--categoryDropdown--40433";
export var containerBar = "PortfolioSlider-module--containerBar--4ee79";
export var content = "PortfolioSlider-module--content--d1b3b";
export var contentWrapper = "PortfolioSlider-module--contentWrapper--63206";
export var date = "PortfolioSlider-module--date--99f6f";
export var description = "PortfolioSlider-module--description--ed494";
export var disabled = "PortfolioSlider-module--disabled--16c78";
export var ellipsis = "PortfolioSlider-module--ellipsis--3c6b3";
export var featuredSection = "PortfolioSlider-module--featuredSection--9b4d5";
export var filterBar = "PortfolioSlider-module--filterBar--bc59c";
export var filterHeading = "PortfolioSlider-module--filterHeading--b2489";
export var filterSection = "PortfolioSlider-module--filterSection--f07ee";
export var globalSpacing = "PortfolioSlider-module--global-spacing--a8a9d";
export var globalSpacingBottom = "PortfolioSlider-module--global-spacing-bottom--c1f8a";
export var globalSpacingTop = "PortfolioSlider-module--global-spacing-top--96c0a";
export var head = "PortfolioSlider-module--head--d1673";
export var image = "PortfolioSlider-module--image--05060";
export var imageBox = "PortfolioSlider-module--imageBox--aa1bc";
export var imageWrapper = "PortfolioSlider-module--imageWrapper--1039b";
export var index = "PortfolioSlider-module--index--d6b69";
export var left = "PortfolioSlider-module--left--5e775";
export var listItem = "PortfolioSlider-module--listItem--e1cc9";
export var maxWidth = "PortfolioSlider-module--max-width--e61d0";
export var navButton = "PortfolioSlider-module--navButton--edc8e";
export var overview = "PortfolioSlider-module--overview--0391f";
export var pagination = "PortfolioSlider-module--pagination--32793";
export var para = "PortfolioSlider-module--para--e47af";
export var paragraphText = "PortfolioSlider-module--paragraphText--2f0e5";
export var projects = "PortfolioSlider-module--projects--7cd7f";
export var right = "PortfolioSlider-module--right--f55e2";
export var styleTick = "PortfolioSlider-module--styleTick--fdee2";
export var tag = "PortfolioSlider-module--tag--5d1e1";
export var tagWrapper = "PortfolioSlider-module--tagWrapper--36e35";
export var title = "PortfolioSlider-module--title--0363b";